import { useEffect, useState } from "react";
import { CheckCircle2, Clock, Mail } from "lucide-react";
import { api } from "@/lib/api";

export default function EmailDomainStatus() {
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/admin/email-status").then((r) => setSt(r.data)).catch(() => {}); }, []);
  if (!st || !st.domain) return null;
  const live = Object.values(st.records).filter(Boolean).length;
  const total = Object.keys(st.records).length;
  const ok = st.brand_verified === true;
  return (
    <div data-testid="email-domain-status" className={`mb-6 flex flex-wrap items-center gap-x-4 gap-y-2 rounded-xl border px-4 py-3 text-sm ${ok ? "border-[#B7D9C0] bg-[#EEF7F0] text-[#2F6B45]" : "border-[#F3D36B] bg-[#FFF9E0] text-[#7A5B00]"}`}>
      <span className="flex items-center gap-2 font-medium"><Mail className="h-4 w-4" />Email sender · {st.domain}</span>
      {ok ? (
        <span className="flex items-center gap-1.5" data-testid="email-domain-verified"><CheckCircle2 className="h-4 w-4" />Verified — customers get mail from {st.brand_from.replace(/.*</, "").replace(">", "")}</span>
      ) : (
        <span className="flex items-center gap-1.5" data-testid="email-domain-pending"><Clock className="h-4 w-4" />Pending — DNS records live: {live}/{total}. Login codes use the Resend sandbox sender until verified.</span>
      )}
      <span className="ml-auto flex gap-2 text-xs">
        {Object.entries(st.records).map(([n, v]) => (
          <span key={n} data-testid={`email-dns-${n.replace(/\W/g, "-")}`} className={`rounded-full px-2 py-0.5 ${v ? "bg-[#B7D9C0]/60" : "bg-white/70 line-through decoration-[#C27B00]/60"}`}>{n}</span>
        ))}
      </span>
    </div>
  );
}
